import type { BranchingRule, RoutingDestination } from './types'

/** Resolve destination from nested `destination` or legacy flat `destinationQuestionId`. */
export function resolveRuleDestination(rule: BranchingRule): RoutingDestination | null {
  if (rule.destination != null) {
    return rule.destination
  }
  const legacyId = rule.destinationQuestionId?.trim()
  if (legacyId) {
    return { destinationQuestionId: legacyId, endOfInstrument: false }
  }
  return null
}

export function ruleDestinationQuestionId(rule: BranchingRule): string | null {
  const dest = resolveRuleDestination(rule)
  if (dest?.endOfInstrument === true) return null
  const id = dest?.destinationQuestionId?.trim()
  return id || null
}
